import { gql } from "@apollo/client";
import { CAMPAIGN_FIELDS } from "./query";

const CREATE_CAMPAIGN = gql`
  mutation createCampaign($input: CreateCampaignInput!) {
    createCampaign(input: $input) {
      campaign {
        ${CAMPAIGN_FIELDS}
      }
    }
  }
`;

const UPDATE_CAMPAIGN = gql`
  mutation updateCampaign($input: UpdateCampaignInput!) {
    updateCampaign(input: $input) {
      campaign {
        ${CAMPAIGN_FIELDS}
      }
    }
  }
`;

const STOP_CAMPAIGN = gql`
  mutation stopCampaign($id: ID!) {
    stopCampaign(id: $id) {
      campaign {
        ${CAMPAIGN_FIELDS}
      }
    }
  }
`;

const DELETE_CAMPAIGN = gql`
  mutation deleteCampaign($id: ID!) {
    deleteCampaign(id: $id) {
      id
    }
  }
`;

// dryRun defaults to true server-side and a real send is gated behind an
// ops-only env flag, so invoking this from the UI is always a safe simulation.
const SEND_CAMPAIGN = gql`
  mutation sendCampaign($input: SendCampaignInput!) {
    sendCampaign(input: $input) {
      campaignId
      dryRun
      totalRecipients
      sent
      failed
      skipped
    }
  }
`;

const REQUEST_SENDER_VERIFICATION = gql`
  mutation requestSenderVerification($input: RequestSenderVerificationInput!) {
    requestSenderVerification(input: $input) {
      email
      verified
      status
    }
  }
`;

export { CREATE_CAMPAIGN, UPDATE_CAMPAIGN, STOP_CAMPAIGN, DELETE_CAMPAIGN, SEND_CAMPAIGN, REQUEST_SENDER_VERIFICATION };
